import React, { useEffect, useRef, useState } from 'react';
import { classIf } from '../data/utils/classIf';
import { scrollToTarget } from '../data/utils/scrollToTarget';
import { labels } from '../data/labels';
import { MatchContext } from '../prematch/match/MatchDataFetcher';

function MacrogruppoSelector(props) {
    const context = React.useContext(MatchContext)
    const [expanded, setExpanded] = useState(false);

    function toggleExpand() {
        setExpanded(!expanded);
        if (expanded) {
            setTimeout(() => {
                if (navbar.current) {
                    const selected = navbar.current.querySelector('.selected');
                    scrollToTarget(navbar.current, selected);
                }
            }, 200);
        }
    }

    function toggleFavorites() {
        context.favoriteMarketsOn();
    }

    const navbar = useRef(null);
    useEffect(() => {
        if (navbar.current && !context) {
            const selected = navbar.current.querySelector('.selected');
            if (navbar.current.firstElementChild !== selected) {
                navbar.current.scrollLeft = selected.getBoundingClientRect().left;
            }
        }
    }, []);

    const favoritesMarketsSelected = context && context.favoritesSelected;

    return (
        <nav className="nav-filters-wrapper">
            <div className={"nav-filters" + classIf(expanded, 'expanded')} ref={navbar}>
                {(context && context.showFavoritesForSport(context.match.sportRef)) &&
                    <div className={"nav-filter-item" + classIf(favoritesMarketsSelected, 'selected')} onClick={toggleFavorites}>{labels['favorite_markets']}</div>
                }
                {props.macrogruppi.map(mg => {
                    function handleClick(e) {
                        props.changeMacrogruppo(mg.id);
                        if (expanded) {
                            setExpanded(!expanded);
                            setTimeout(() => {
                                if (navbar.current) {
                                    scrollToTarget(navbar.current, e.target);
                                }
                            }, 200);
                        }
                    }
                    return <div key={mg.id} className={"nav-filter-item" + classIf(!favoritesMarketsSelected && mg.id === props.macrogruppo, 'selected')} onClick={handleClick}>{mg.descrizione}</div>
                })}
                {expanded &&
                    <div className="nav-filters-close-button" onClick={toggleExpand}>
                        <i className="far fa-times-circle"></i>
                    </div>
                }
            </div>
            {props.macrogruppi.length > 3 &&
                <div className="nav-filters-expand-button" onClick={toggleExpand}>
                    <i className="fa fa-angle-down"></i>
                </div>
            }
        </nav>
    );
}

export default MacrogruppoSelector;